import { findFirst } from 'fp-ts/lib/Array';
import { fromPredicate, none, some } from 'fp-ts/lib/Option';
import { query } from 'sdi/shape/functions';
import { HarvestedLayer } from '../components/query';
import {
    CircleHarvesting,
    CircleOptions,
    Drawing,
    geometryTypeOfShape,
    Harvesting,
    HarvestStep,
} from '../shape/types';

export const getHarvestStep = () => query('component/harvest');

const isCircleOptions = (hs: HarvestStep): hs is CircleOptions =>
    hs.state === 'circle-options';

const isDrawing = (hs: HarvestStep): hs is Drawing => hs.state === 'drawing';

const isHarvesting = (hs: HarvestStep): hs is Harvesting =>
    hs.state === 'harvesting';

const isCircleHarvesting = (h: Harvesting): h is CircleHarvesting =>
    h.shape === 'circle';

export const getCircleOptions = () =>
    fromPredicate(isCircleOptions)(getHarvestStep());

export const getDrawing = () => fromPredicate(isDrawing)(getHarvestStep());

export const getHarvesting = () =>
    fromPredicate(isHarvesting)(getHarvestStep());

export const getDrawingCircleRadius = () =>
    getDrawing().chain(d => (d.shape === 'circle' ? some(d.radius) : none));

export const getHarvestCircle = () =>
    getHarvesting().chain(fromPredicate(isCircleHarvesting));

export const formatRadius = (m: number): string =>
    m < 1000 ? `${m} m` : `${m / 1000} km`;

export const getGeometry = () => getHarvesting().map(hs => hs.geometry);

export const getGeometryType = () =>
    getDrawing().map(hs => geometryTypeOfShape(hs.shape));

export const getHarvestedLayers = () => getHarvesting().map(hs => hs.results);

export const findHarvestedLayer = (mapId: string, mid: string) =>
    getHarvestedLayers().chain(
        findFirst(
            (layer: HarvestedLayer) =>
                layer.mapId === mapId && layer.metadataId === mid,
        ),
    );
